import React from 'react';

const TemplateFilters = ({
    subcategories,
    activeSubcategory,
    onSubcategoryChange,
    jurisdictions,
    activeJurisdiction,
    onJurisdictionChange,
}) => {
    return (
        <aside className="templates-sidebar">
            <div className="templates-filter-section">
                <h4>Category</h4>
                <div className="templates-filter-list">
                    {subcategories.map((sub) => (
                        <button
                            key={sub}
                            className={`filter-pill ${activeSubcategory === sub ? 'active' : ''}`}
                            onClick={() => onSubcategoryChange(sub)}
                        >
                            {sub}
                        </button>
                    ))}
                </div>
            </div>

            <div className="templates-filter-section">
                <h4>Jurisdiction</h4>
                <select
                    className="jurisdiction-select"
                    value={activeJurisdiction}
                    onChange={(e) => onJurisdictionChange(e.target.value)}
                >
                    {jurisdictions.map((j) => (
                        <option key={j} value={j}>
                            {j}
                        </option>
                    ))}
                </select>
            </div>
        </aside>
    );
};

export default TemplateFilters;
